import { render, staticRenderFns } from "./OrderCompleteDialog.vue?vue&type=template&id=019ce384"
import script from "./OrderCompleteDialog.vue?vue&type=script&lang=js"
export * from "./OrderCompleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports